'use client';
import { DecoratedImage } from 'src/ui/DecoratedImage';
import type { IPageStory, IStoryFields } from 'types/generated/contentful';
import type { Document } from '@contentful/rich-text-types';
import { PostRenderer } from 'src/cms/PostRenderer';
import { CTA } from 'src/ui/blocks';
import { Grid, Limit, Narrow, Section } from 'src/ui/layout';
import { Story } from 'src/ui/Story';
import { H1, H2 } from 'src/ui/typography';
import { Video } from 'src/ui/Video';

interface Props {
  document?: Document | undefined;
  story: IStoryFields;
  related?: Array<IPageStory> | undefined;
}

export default function Content({ story, document, related }: Props) {
  return (
    <>
      <Section>
        <Narrow alignItems="center">
          {story?.logotype?.fields && (
            <DecoratedImage
              src={story.logotype.fields.file.url}
              alt={story.logotype.fields?.title ?? ''}
              height="40px"
              mb="space4"
            />
          )}
          <Limit>
            <H1 textAlign="center" mb="space4">
              {story?.title}
            </H1>
          </Limit>
          {story?.video ? (
            <Video
              title={story.title}
              url={story.video}
              preview={story.image.fields?.file.url}
            />
          ) : (
            <DecoratedImage
              src={story?.image.fields?.file.url ?? ''}
              alt={story?.image.fields?.title ?? ''}
            />
          )}
        </Narrow>
      </Section>
      <Section>
        <Narrow>{document && <PostRenderer document={document} />}</Narrow>
      </Section>
      {related && (
        <Section>
          <Narrow>
            <H2>More customer stories</H2>
            <Grid col={2} gutter={2}>
              {related.map(({ fields, sys }) => (
                <Story
                  key={sys.id}
                  image={fields?.story.fields?.image.fields?.file.url ?? ''}
                  title={fields?.story.fields?.title ?? ''}
                  slug={fields?.slug}
                  logotype={fields?.story.fields?.logotype?.fields?.file.url}
                  logotypeAlt={fields?.story.fields?.logotype?.fields?.title}
                />
              ))}
            </Grid>
          </Narrow>
        </Section>
      )}
      <CTA />
    </>
  );
}
